export enum Client {
    MLRS = "ra-mlrs",
    BABCOCK = "babcock",
    VRAIDT = "vraidt",
    VRAIDT_VBS = "vrai-dt-vbs",
    IDAS = "idas",
    ODYSSEY_BAE_UKSOUTH = "bae",
    UNREAL_DEMO = "unreal-demo",
}
